// Central config for React client

const dev = {
  REACT_APP_DISCORD_REDIRECT_URI: 'http://localhost:3000/callback'
};

const prod = {
  REACT_APP_DISCORD_REDIRECT_URI: 'https://darkedge.app/callback'
};

const config = { 
  ...(process.env.NODE_ENV === 'production' ? prod : dev),
  REACT_APP_DISCORD_CLIENT_ID: '1279120992526012508',
  DISCORD_INVITE_LINK: 'https://discord.gg/4Sy9nGasJV',
  UPGRADE_CHAT_LINK: 'https://chat-tier.com/my/orders',
  WEBSOCKET_PING_INTERVAL: 20000,
  WEBSOCKET_TIMEOUT: 30000,
  SERVER_PORT: 8080,
  PRICING_LINK: "https://chat-tier.com/dark-edge",
  VPS_PROVIDER_LINK: "https://my.hostbrr.com/order/main/packages/budgetryzen/?group_id=34&a=ODE0OQ==",
  CPP_INSTALL_LINK: "https://aka.ms/vs/17/release/vc_redist.x86.exe",
  LAUNCHER_DOWNLOAD_LINK: "https://github.com/mkyriakou3/dark-edge-release/releases/download/latest/DarkEdge.Launcher.zip",
  SETUP_LINK: "https://discord.com/channels/1279120541659435090/1321910645150580758",
  // elitepvpers release thread backlink shown in the footer
  EPVP_URL: "https://www.elitepvpers.com/forum/darkorbit-trading/5319479-release-darkedge-unity-bot.html",
  EPVP_FAVICON_URL: "https://www.elitepvpers.com/favicon.ico",
  BOT_CONFIG_IMAGES: [
    "AvoidRegionEditor.png",
    "BackgroundTasks_GGSpinnerFeat.png",
    "KillNCollect.png",
    "LocaleChangeTR.png",
    "Login.png",
    "ModderFeatures.png",
    "PreferredRegionEditor.png",
    "ProfileSwitcher.png",
    "ProxySupport.png",
    "Stats_Items.png",
    "Tool.png",
    "UISettings.png",
  ],
  BOT_MAIN_IMAGES: [
    "BotWindow_BoxCollect.png",
    "attends.png",
    "cubi-grave.png",
  ]
};

export default config;
